import React, { useState, useMemo } from "react";
import { usePage } from "@inertiajs/inertia-react";
import { Popover } from "@material-ui/core";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

export default function ClientSwitcher() {
    const { client, userClients, user, permissions, } = usePage().props;
    const [clientSwitchElement, setClientSwitchElement] = useState(null);
    const clientSwitchOpen = Boolean(clientSwitchElement);
    const filteredClients = userClients.filter(item => item.id !== client.id);

    if (!user?.id || !userClients || filteredClients.length <= 1 || !permissions?.includes("queue_switch_client")) {
        return <div className={"ml-7"} />;
    }

    const handleClientSwitchClick = (event) => {
        if (clientSwitchOpen) {
            setClientSwitchElement(null);
            return;
        }
        setClientSwitchElement(event.currentTarget);
    };

    const handleClientPopoverClose = () => {
        setClientSwitchElement(null);
    };



    return (
        <div
            className="flex items-center justify-center cursor-pointer hover:opacity-70 ml-7"
            onClick={handleClientSwitchClick}
            title="Switch Client"
        >

            <SwapHorizIcon
                style={{
                    color: client.brand_color_header_icons,
                }}
            />
            <Popover
                id={clientSwitchOpen ? "client-switch-popover" : undefined}
                open={clientSwitchOpen}
                anchorEl={clientSwitchElement}
                onClose={handleClientPopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                PaperProps={{
                    style: {
                        borderRadius: 8,
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                    }
                }}
            >
                <div className="bg-white rounded-lg overflow-hidden w-56">
                    <div className="flex items-center gap-1 text-gray-500 text-xs px-5 py-3 border-b">
                        <SwapHorizIcon style={{ fontSize: 14 }} />
                        <span className="font-medium">Available clients ({filteredClients.length})</span>
                    </div>
                    <div className="max-h-[300px] overflow-y-auto py-1">
                        {filteredClients.map((clientItem) => (
                            <a
                                key={clientItem.id}
                                href={route("client.switch", { client_id: clientItem.id })}
                                className="block px-5 py-3 text-gray-700 hover:bg-gray-50 border-l-4 border-transparent
                                         font-medium transition-all duration-200 text-sm hover:border-blue-500 hover:border-l-4 no-underline"
                            >
                                {clientItem.name}
                            </a>
                        ))}
                    </div>
                </div>
            </Popover>
        </div>
    );
}
